module.exports = __webpack_public_path__ + "img/slide-4.500714f9.png";